import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import IconButton from "@material-ui/core/IconButton";
import { connectUserStore } from "../../../hoc/connectStore/connectUserStore";
import UserAvatar from "../../UI/UserAvatar/UserAvatar";
import UserIcon from "../../UI/Icons/UserIcon";

const HeaderPanel = (props) => {
  const { classes, handleProfileMenuOpen, menuId, matches, loading } = props;

  return (
    <Wrapper>
      <div>
        <IconButton
          aria-controls={menuId}
          aria-haspopup="true"
          onClick={handleProfileMenuOpen}
          color="inherit"
        >
          {props && props.profile && !loading ? (
            <UserAvatar size={30} name={props.profile.fullname} />
          ) : (
            <UserIcon width={24} height={24} fill={"rgba(0,0,0,0.6)"} />
          )}
        </IconButton>
      </div>
    </Wrapper>
  );
};

export default connectUserStore(HeaderPanel);
